export const NEW_BOOKING_FORM = 'booking-information/form';
export const ADMISSION_FORM = 'admission-form';
export const TRAIL_FORM = 'trail-form';
